import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';


import Post_Img_1 from "../../img/news/post_img_1.webp";
import Post_Img_2 from "../../img/news/post_img_2.webp";
import Post_Img_3 from "../../img/news/post_img_3.webp";

function News() {
    const newsList = [
        {
            title: 'Рішуча. Справжня. Небайдужа — ключові інсайти та історії SHE Congress 2025',
            img: Post_Img_1,
            link: 'https://womo.ua/category/business/she-congress-2025-u-kyyevi-platforma-shho-nadyhaye-ta-obyednuye-zhinok-u-biznesi-osviti-ta-socziumi/ '
        },
        {
            title: 'Не про дипломи, а про стійкість: розмова жінок-лідерок про освіту на SHE Congress 2025',
            img: Post_Img_2,
            link: 'https://womo.ua/category/business/ne-pro-dyplomy-a-pro-stijkist-rozmova-zhinok-liderok-pro-osvitu-na-she-congress-2025/'
        },
        {
            title: 'He for She на She Congress 2025: чоловічий погляд на жіноче лідерство та стратегічні зміни в бізнесі',
            img: Post_Img_3,
            link: 'https://womo.ua/category/business/he-for-she-na-she-congress-2025-cholovichyj-poglyad-na-zhinoche-liderstvo-ta-strategichni-zminy-v-biznesi/'
        },
    ];

    return (
        <section className="mb-[60px] lg:mb-[120px]">
            <div className="container max-w-screen-xl mx-auto px-5">
                <ScrollAnimation animateIn="animate__fadeInUp">
                    <h2 className="font-bold uppercase text-3xl text-center text-[#245864] mb-8
                    sm:text-4xl md:mb-14 lg:text-left lg:text-[60px] relative z-20">ЧИТАТИ ПРО SHE CONGRESS 2025</h2>
                </ScrollAnimation>
                
                <ScrollAnimation animateIn="animate__fadeInUp">
                    <div className="grid gap-14 md:grid-cols-3 mb-12">
                        {newsList.map((item, index) => (
                            <article key={index}>
                                <div className="mb-4">
                                    <img  src={item.img}  alt={item.title} className="w-full"
                                    />
                                </div>

                                <h3 className="mb-4 font-bold text-xl">
                                    {item.title}
                                </h3>

                                <a href={item.link}  target="_blank" rel="noopener noreferrer"
                                    className="inline-block text-center text-base bg-[#F5D858] text-black font-bold px-3 py-2 
                                        tracking-widest hover:scale-105 transition-all duration-300 ease-out">
                                    Читати більше
                                </a>
                            </article>
                        ))}
                    </div>
                </ScrollAnimation>

                <div className="text-center">
                    <a href="https://womo.ua/?s=she+congress"  target="_blank" rel="noopener noreferrer"
                        className="inline-block text-center text-base bg-[#245864] text-white  font-bold px-8 py-3 uppercase
                            tracking-widest hover:scale-105 transition-all duration-300 ease-out">
                        Читати все
                    </a>
                </div>
            </div>
        </section>
    );
}

export default News;